import agent from './agent';

//Method to get tab name from URL
const getTabName = () => {
  let tab;
  let subRoute = window.location.pathname.replace('/website','');
  if(subRoute) {
    if(subRoute.indexOf('/sites') !== -1) {
      tab = 'sites';
    }else if(subRoute.indexOf('/table/') !== -1){
      subRoute = subRoute.replace('/table/','');
      tab = subRoute.split('/')[0];
    }
  }
  return tab;
}

const getTableName = () => {
  let subRoute = window.location.pathname.replace('/website','');
  if(subRoute && subRoute.indexOf('/table/') !== -1) {
      subRoute = subRoute.replace('/table/','');
      return subRoute.split('/')[0];
  }
  return '';
}

const prepareData = (obj) => {
  let stdAttributes = ['id', 'createdBy', 'modifiedBy', 'createdAt', 'modifiedAt'];
  let updatedObj = Object.assign({}, obj);
  stdAttributes.forEach(attr => {
    delete updatedObj[attr];
  });
  return updatedObj;
}

const goBack = () => {
  window.history.back();
}

const wait = (ms) => {
  return new Promise(resolve => setTimeout(resolve, ms));
}

function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

async function getRecordsModifiedAfter(tableId, timestamp, recordId) {
  let searchList = [{
      column: "modifiedAt",
      operator: ">", 
      value: timestamp
    }];

  if(timestamp) {
    let result = await agent.Data.search(tableId, searchList);
    return result;
  }else {
    return [];
  }
};

async function searchRecords(tableId, columnName, searchKey) {
  var strlength = searchKey.length;
  var strFrontCode = searchKey.slice(0, strlength-1);
  var strEndCode = searchKey.slice(strlength-1, searchKey.length);

  var startcode = searchKey;
  var endcode= strFrontCode + String.fromCharCode(strEndCode.charCodeAt(0) + 1);
  let searchList = [{
      column: columnName,
      operator: ">=", 
      value: startcode
    },{
      column: columnName,
      operator: "<", 
      value: endcode
    }];

  let result = await agent.Data.search(tableId, searchList);
  return result;
};

export {
  getTabName,
  getTableName,
  prepareData,
  goBack,
  wait,
  debounce,
  searchRecords,
  getRecordsModifiedAfter
};